"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigHelper = void 0;
var ConfigHelper = /** @class */ (function () {
    function ConfigHelper() {
    }
    ConfigHelper.parseMapFromString = function (input) {
        var output = {};
        if (!input || input === "") {
            return output;
        }
        var variables = input.split(';');
        for (var _i = 0, variables_1 = variables; _i < variables_1.length; _i++) {
            var variable = variables_1[_i];
            var parts = variable.split('=');
            if (parts.length !== 2) {
                throw new Error("Can't parse string " + input + " as headers string.");
            }
            output[parts[0]] = parts[1];
        }
        return output;
    };
    ConfigHelper.mapToQueryString = function (input) {
        var paramsArray = [];
        for (var _i = 0, _a = Object.keys(input); _i < _a.length; _i++) {
            var key = _a[_i];
            paramsArray.push(key + "=" + input[key]);
        }
        return paramsArray.join("&");
    };
    return ConfigHelper;
}());
exports.ConfigHelper = ConfigHelper;
//# sourceMappingURL=ConfigHelper.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/utils/ConfigHelper.js
// module id = 2036
// module chunks = 0